





















import { mapActions } from 'vuex';

import GenericCard from '@/components/cards/GenericCard.vue';
import { ModalSize } from '@/components/zen_modal/types';

export default {
  name: 'ListingRemoveFavoriteModal',
  components: {
    GenericCard,
  },
  created() {
    this.changeModalSize(ModalSize.Small);
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      cancelModal: 'modals/cancel',
      confirmModal: 'modals/confirm',
    }),
    cancel(): void {
      this.cancelModal();
    },
    save(): void {
      this.confirmModal(true);
    },
  },
};
